// extracted by mini-css-extract-plugin
export default {"root":"PlasmicTextarea_root__Kj-d0"};